<template>
  <div class="ip-whitelist-blocked">
    <p class="ip-whitelist-blocked__title">
      <strong>IP Whitelist Blocked</strong>
    </p>
    <p class="ip-whitelist-blocked__text">
      Your account has IP whitelist enabled for security. Your current IP address is not whitelisted.
    </p>
    <p class="ip-whitelist-blocked__text">
      <strong>What can you do?</strong>
    </p>
    <p class="ip-whitelist-blocked__text">
      1. Contact us at <a href="mailto:support@scrapingant.com">support@scrapingant.com</a> to add your IP address to the whitelist
    </p>
    <p class="ip-whitelist-blocked__text">
      2. Try logging in from a whitelisted IP address
    </p>
  </div>
</template>

<script>
export default {
  name: "IpWhitelistBlockedMessage",
};
</script>

<style scoped lang="scss">
.ip-whitelist-blocked {
  text-align: left;

  &__title {
    margin-bottom: 16px;
    font-size: 14px;
    line-height: 24px;
  }

  &__text {
    margin-bottom: 8px;
    font-size: 14px;
    line-height: 24px;
    font-weight: 400;

    &:last-child {
      margin-bottom: 0;
    }

    a {
      color: inherit;
    }
  }
}
</style>
